import React, { useEffect, useMemo } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import FullPageWithHeaderAndProgress from "pages/container/FullPageWithHeaderAndProgress";
import { Acquisition_1 } from "./part/acquisition/Acquisition_1";
import Habit_2_QnA from "./part/habit/Habit_2_QnA";
import Goal_2_MultiSelect_1 from "./part/goal/Goal_2_MultiSelect_1";
import Goal_1 from "./part/goal/Goal_1";
import Goal_3_MultiSelect_2 from "./part/goal/Goal_3_MultiSelect_2";
import Goal_4 from "./part/goal/Goal_4";
import Goal_5 from "./part/goal/Goal_5";
import Goal_6 from "./part/goal/Goal_6";
import Goal_7 from "./part/goal/Goal_7";
import Goal_8 from "./part/goal/Goal_8";
import Goal_9 from "./part/goal/Goal_9";
import Goal_10 from "./part/goal/Goal_10";
import Goal_11 from "./part/goal/Goal_11";
import Goal_12 from "./part/goal/Goal_12";
import Convention_1 from "./part/convention/Convention_1";
import Convention_2_QnA from "./part/convention/Convention_2_QnA";
import Convention_3 from "./part/convention/Convention_3";
import NicknameSubmit from "./part/NicknameSubmit";
import Habit_1 from "./part/habit/Habit_1";
import Habit_3 from "./part/habit/Habit_3";
import Habit_4 from "./part/habit/Habit_4";
import Habit_5 from "./part/habit/Habit_5";
import Motivation_1 from "./part/motivation/Motivation_1";
import Motivation_3 from "./part/motivation/Motivation_3";
import Motivation_2 from "./part/motivation/Motivation_2";
import Motivation_4 from "./part/motivation/Motivation_4";
import Motivation_6 from "./part/motivation/Motivation_6";
import Motivation_5 from "./part/motivation/Motivation_5";
import Motivation_7_MultiSelect from "./part/motivation/Motivation_7_MultiSelect";
import Motivation_8 from "./part/motivation/Motivation_8";
import Result_4 from "./part/result/Result_4";
import Result_1 from "./part/result/Result_1";
import FullPageWithCenterContentV2 from "../container/FullPageWithCenterContentV2";
import { theme } from "../../styles/theme";
import Result_2 from "./part/result/Result_2";
import Result_3 from "./part/result/Result_3";
import Acquisition_3 from "./part/acquisition/Acquisition_3";
import { useOnboardingProgress } from "../../hooks/useOnboardingProgress";
import useMixpanelWeb from "../../hooks/useMixpanelWeb";
import { OnboardingLoad } from "./part/load/OnboardingLoad";
import { userAtom } from "../../recoil/userAtom";
import { useRecoilValue } from "recoil";
import Demographic_1 from "./part/demographic/Demographic_1";
import Demographic_2 from "./part/demographic/Demographic_2";
import Demographic_3 from "./part/demographic/Demographic_3";
import Demographic_4 from "./part/demographic/Demographic_4";
import PaymentContentDefault from "../../components/task/payment/PaymentContentDefault";
import Habit_6 from "./part/habit/Habit_6";
import Habit_7 from "./part/habit/Habit_7";
import Curriculum_1 from "./part/curriculum/Curriculum_1";
import CrossFunnel_Loading from "./part/crossFunnel/CrossFunnel_Loading";
import ProductContent from "../../components/task/payment/ProductContent";
import Introduction_1 from "./part/introduction/Introduction_1";
import Introduction_2 from "./part/introduction/Introduction_2";
import Introduction_3 from "./part/introduction/Introduction_3";
import Introduction_4 from "./part/introduction/Introduction_4";
import Introduction_5 from "./part/introduction/Introduction_5";
import Introduction_6 from "./part/introduction/Introduction_6";
import { writeLastStep } from "../../utils/onboardingStorage";
import { OnboardingLoadV2 } from "./part/load/OnboardingLoadV2";

interface OnboardingStep {
  type: string;
  seqByType: number;
  title?: string;
  hideHeader?: boolean;
  hideProgress?: boolean;
  disableBack?: boolean;
  progressDelta?: number;
  centerFullScreen?: boolean;
  backgroundColor?: string;
  paddingXContent?: number;
  content: React.ReactNode;
}

const w2aSteps: OnboardingStep[] = [
  {
    type: "load",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <OnboardingLoad />,
  },
  {
    type: "w2a-loading",
    seqByType: 1,
    centerFullScreen: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <CrossFunnel_Loading />,
  },
  {
    type: "nickname",
    seqByType: 1,
    hideProgress: true,
    disableBack: true,
    content: <NicknameSubmit />,
  },
  {
    type: "demographic",
    seqByType: 2,
    hideProgress: true,
    content: <Demographic_2 />,
  },
  {
    type: "demographic",
    seqByType: 3,
    hideProgress: true,
    content: <Demographic_3 />,
  },
  {
    type: "demographic",
    seqByType: 4,
    hideProgress: true,
    content: <Demographic_4 />,
  },
];

const commonPrefixSteps: OnboardingStep[] = [
  {
    type: "load",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <OnboardingLoad />,
  },
  {
    type: "acquisition",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <Acquisition_1 />,
  },
  {
    type: "acquisition",
    seqByType: 3,
    hideProgress: true,
    content: <Acquisition_3 />,
  },
];

const commonPrefixSimpleSteps: OnboardingStep[] = [
  {
    type: "load",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <OnboardingLoadV2 />,
  },
  {
    type: "acquisition",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <Acquisition_1 />,
  },
];

const demographicSteps: OnboardingStep[] = [
  {
    type: "demographic",
    seqByType: 1,
    title: "기본 정보",
    progressDelta: 1 / 4,
    disableBack: true,
    content: <Demographic_1 />,
  },
  {
    type: "demographic",
    seqByType: 2,
    title: "기본 정보",
    progressDelta: 2 / 4,
    content: <Demographic_2 />,
  },
  {
    type: "demographic",
    seqByType: 3,
    title: "기본 정보",
    progressDelta: 3 / 4,
    content: <Demographic_3 />,
  },
  {
    type: "demographic",
    seqByType: 4,
    title: "기본 정보",
    progressDelta: 4 / 4,
    content: <Demographic_4 />,
  },
];

const mainContentSteps: OnboardingStep[] = [
  {
    type: "goal",
    seqByType: 1,
    title: "고민과 목표",
    disableBack: true,
    progressDelta: 1 / 7,
    content: <Goal_1 />,
  },
  {
    type: "goal",
    seqByType: 2,
    title: "고민과 목표",
    progressDelta: 2 / 7,
    content: <Goal_2_MultiSelect_1 />,
  },
  {
    type: "goal",
    seqByType: 3,
    title: "고민과 목표",
    progressDelta: 3 / 7,
    content: <Goal_3_MultiSelect_2 />,
  },
  {
    type: "goal",
    seqByType: 4,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Goal_4 />,
  },
  {
    type: "goal",
    seqByType: 5,
    title: "고민과 목표",
    progressDelta: 4 / 7,
    content: <Goal_5 />,
  },
  {
    type: "goal",
    seqByType: 6,
    title: "고민과 목표",
    progressDelta: 5 / 7,
    content: <Goal_6 />,
  },
  {
    type: "goal",
    seqByType: 7,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Goal_7 />,
  },
  {
    type: "goal",
    seqByType: 8,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Goal_8 />,
  },
  {
    type: "goal",
    seqByType: 9,
    title: "고민과 목표",
    progressDelta: 6 / 7,
    content: <Goal_9 />,
  },
  {
    type: "goal",
    seqByType: 10,
    hideProgress: true,
    content: <Goal_10 />,
  },
  {
    type: "goal",
    seqByType: 11,
    hideHeader: true,
    hideProgress: true,
    content: <Goal_11 />,
  },
  {
    type: "goal",
    seqByType: 12,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Goal_12 />,
  },
  {
    type: "convention",
    seqByType: 1,
    title: "인식과 기대",
    disableBack: true,
    progressDelta: 1 / 12,
    content: <Convention_1 />,
  },
  {
    type: "convention",
    seqByType: 2,
    title: "인식과 기대",
    progressDelta: 1 / 12,
    content: <Convention_2_QnA />,
  },
  {
    type: "convention",
    seqByType: 3,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Convention_3 />,
  },
  {
    type: "nickname",
    seqByType: 1,
    hideProgress: true,
    content: <NicknameSubmit />,
  },
  {
    type: "habit",
    seqByType: 1,
    title: "습관과 노력",
    disableBack: true,
    progressDelta: 1 / 7,
    content: <Habit_1 />,
  },
  {
    type: "habit",
    seqByType: 2,
    title: "습관과 노력",
    progressDelta: 1 / 7,
    content: <Habit_2_QnA />,
  },
  {
    type: "habit",
    seqByType: 3,
    hideProgress: true,
    content: <Habit_3 />,
  },
  {
    type: "habit",
    seqByType: 4,
    hideHeader: true,
    hideProgress: true,
    content: <Habit_4 />,
  },
  {
    type: "habit",
    seqByType: 5,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Habit_5 />,
  },
  {
    type: "habit",
    seqByType: 6,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Habit_6 />,
  },
  {
    type: "habit",
    seqByType: 7,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Habit_7 />,
  },
  {
    type: "motivation",
    seqByType: 1,
    title: "의지와 동기",
    disableBack: true,
    progressDelta: 1 / 6,
    content: <Motivation_1 />,
  },
  {
    type: "motivation",
    seqByType: 2,
    title: "의지와 동기",
    progressDelta: 2 / 6,
    content: <Motivation_2 />,
  },
  {
    type: "motivation",
    seqByType: 3,
    title: "의지와 동기",
    progressDelta: 3 / 6,
    content: <Motivation_3 />,
  },
  {
    type: "motivation",
    seqByType: 4,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Motivation_4 />,
  },
  {
    type: "motivation",
    seqByType: 5,
    title: "의지와 동기",
    progressDelta: 4 / 6,
    content: <Motivation_5 />,
  },
  {
    type: "motivation",
    seqByType: 6,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Motivation_6 />,
  },
  {
    type: "motivation",
    seqByType: 7,
    title: "의지와 동기",
    progressDelta: 5 / 6,
    content: <Motivation_7_MultiSelect hideNextButton={false} />,
  },
  {
    type: "motivation",
    seqByType: 8,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Motivation_8 />,
  },
];

const introductionSteps: OnboardingStep[] = [
  {
    type: "introduction",
    seqByType: 1,
    disableBack: true,
    hideProgress: true,
    content: <Introduction_1 />,
  },
  {
    type: "introduction",
    seqByType: 2,
    hideProgress: true,
    paddingXContent: 0,
    content: <Introduction_2 />,
  },
  {
    type: "introduction",
    seqByType: 3,
    hideProgress: true,
    content: <Introduction_3 />,
  },
  {
    type: "introduction",
    seqByType: 4,
    hideProgress: true,
    content: <Introduction_4 />,
  },
  {
    type: "introduction",
    seqByType: 5,
    hideProgress: true,
    content: <Introduction_5 />,
  },
  {
    type: "introduction",
    seqByType: 6,
    hideProgress: true,
    content: <Introduction_6 />,
  },
];

const resultContentSimpleSteps: OnboardingStep[] = [
  {
    type: "product",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <></>,
  },
  {
    type: "payment",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <></>,
  },
];

const resultContentSteps: OnboardingStep[] = [
  {
    type: "result",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <Result_1 />,
  },
  {
    type: "result",
    seqByType: 2,
    centerFullScreen: true,
    backgroundColor: theme.vars.palette.Surface.Highlight,
    content: <Result_2 />,
  },
  {
    type: "result",
    seqByType: 3,
    centerFullScreen: true,
    backgroundColor: theme.vars.palette.Background.SoftHighlight,
    content: <Result_3 />,
  },
  {
    type: "result",
    seqByType: 4,
    hideHeader: true,
    hideProgress: true,
    content: <Result_4 />,
  },
  {
    type: "curriculum",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    backgroundColor: theme.vars.palette.Background.Level3,
    content: <Curriculum_1 />,
  },
  {
    type: "product",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <></>,
  },
  {
    type: "payment",
    seqByType: 1,
    hideHeader: true,
    hideProgress: true,
    content: <></>,
  },
];

function findIndexByStepInfo(
  steps: OnboardingStep[],
  type: string,
  seqByType: number
): number {
  return steps.findIndex(
    (step) => step.type === type && step.seqByType === seqByType
  );
}

export default function OnboardingScreen() {
  const { type, id } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const user = useRecoilValue(userAtom);

  const steps = useMemo(() => {
    if (user?.isWebFunnelRegister) {
      return [...w2aSteps, ...resultContentSteps];
    }

    if (user?.onboardingType === "f") {
      return [
        ...commonPrefixSimpleSteps,
        ...introductionSteps,
        ...resultContentSimpleSteps,
      ];
    }

    if (user?.onboardingType === "g") {
      return [...commonPrefixSimpleSteps, ...introductionSteps];
    }
    return [
      ...commonPrefixSteps,
      ...demographicSteps,
      ...mainContentSteps,
      ...resultContentSteps,
    ];
  }, [user?.isWebFunnelRegister, user?.onboardingType]);

  const numId = parseInt(id || "0");
  const questionNumber = searchParams.get("q");

  const currentStepIndex = Math.min(
    Math.max(findIndexByStepInfo(steps, type!!, numId), 0),
    steps.length - 1
  ); // 유효한 범위 내로 제한

  const currentStep = steps[currentStepIndex];

  const handleBack = () => {
    if (currentStepIndex <= 0) return;

    if (
      (currentStep.type === "convention" || currentStep.type === "habit") &&
      currentStep.seqByType === 2
    ) {
      if (questionNumber !== undefined && parseInt(questionNumber!!) > 1) {
        const prevQuestion = parseInt(questionNumber!!) - 1;
        navigate(
          `/onboarding_new/${currentStep.type}/${currentStep.seqByType}?q=${prevQuestion}`
        );
      } else {
        const prevStep = steps[currentStepIndex - 1];
        navigate(`/onboarding_new/${prevStep.type}/${prevStep.seqByType}`);
      }
      return;
    }

    if (currentStep.type === "convention" && currentStep.seqByType === 3) {
      navigate(
        `/onboarding_new/${currentStep.type}/${currentStep.seqByType - 1}?q=10`
      );
      return;
    }

    if (currentStep.type === "habit" && currentStep.seqByType === 3) {
      navigate(
        `/onboarding_new/${currentStep.type}/${currentStep.seqByType - 1}?q=5`
      );
      return;
    }

    const prevStep = steps[currentStepIndex - 1];
    navigate(`/onboarding_new/${prevStep.type}/${prevStep.seqByType}`);
  };

  useEffect(() => {
    if (!type || !id) return;
    if (user?.onboardingType !== "f") return;
    if (type === "load") return;
    try {
      writeLastStep({
        type,
        seqByType: parseInt(id, 10),
        q: questionNumber ? parseInt(questionNumber, 10) : undefined,
      });
    } catch (e) {
      // noop
    }
  }, [type, id, questionNumber, user?.onboardingType]);

  const { setProgress, setSectionCount } = useOnboardingProgress();

  useEffect(() => {
    if (currentStep.progressDelta) {
      let ratio = 1;
      if (questionNumber !== undefined && parseInt(questionNumber!!) > 0) {
        ratio = parseInt(questionNumber!!);
      }

      if (user?.onboardingType === "c") {
        // 6개 섹션, 각 16%
        setSectionCount(6);
        if (currentStep.type === "demographic") {
          setProgress(0 + 16 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "goal") {
          setProgress(16 + 16 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "convention") {
          setProgress(32 + 16 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "habit") {
          setProgress(48 + 16 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "motivation") {
          setProgress(64 + 16 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "openness") {
          let progress = 80 + 16 * currentStep.progressDelta * ratio;
          setProgress(Math.min(progress, 100)); // 100을 넘지 않도록
        }
      } else {
        // 5개 섹션, 각 20%
        setSectionCount(5);
        if (currentStep.type === "demographic") {
          setProgress(0 + 20 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "goal") {
          setProgress(20 + 20 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "convention") {
          setProgress(40 + 20 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "habit") {
          setProgress(60 + 20 * currentStep.progressDelta * ratio);
        } else if (currentStep.type === "motivation") {
          let progress = 80 + 20 * currentStep.progressDelta * ratio;
          setProgress(Math.min(progress, 100)); // 100을 넘지 않도록
        }
      }
    }
  }, [currentStep, questionNumber, setProgress, user?.onboardingType]);

  const setMixPanel = useMixpanelWeb({
    eventName: "온보딩",
    params: {
      type: `${currentStep.type}`,
      pageId: `${currentStep.seqByType}`,
    },
  });

  useEffect(() => {
    if (type === "load") return;
    if (type === "payment") return;
    if (type === "product") return;
    if (type === "curriculum") return;
    if (type === "w2a-loading") return;

    setMixPanel();
  }, [type, id]);

  if (currentStep.type === "payment") {
    return (
      <div className="w-full h-full overflow-x-hidden">
        {<PaymentContentDefault isFromOnboarding={true} />}
      </div>
    );
  }

  if (currentStep.type === "product") {
    return (
      <div className="w-full h-full overflow-x-hidden">
        {<ProductContent />}
      </div>
    );
  }

  return currentStep.centerFullScreen === true ? (
    <FullPageWithCenterContentV2
      content={currentStep.content}
      backgroundColor={currentStep.backgroundColor}
    />
  ) : (
    <FullPageWithHeaderAndProgress
      headerTitle={currentStep.title}
      hideHeader={currentStep.hideHeader}
      hideProgress={currentStep.hideProgress}
      paddingXContent={currentStep.paddingXContent}
      body={currentStep.content}
      backgroundColor={currentStep.backgroundColor}
      disableBack={currentStep.disableBack}
      onBack={currentStepIndex > 0 ? handleBack : undefined} // 첫 번째 단계에서는 뒤로가기 버튼 숨김
    />
  );
}
